import moment from "moment";
import {
  SUBMIT_ACTIONS,
  DEFAULT_NEXT_TRANSMISSION_CYCLE_DAYS,
} from "static/constants";

export const transmissionModalAction = {
  toggleModal: (state, action) => {
    const { type, value } = action.payload;

    switch (type) {
      case "download": {
        state.isDownloadModal = value;
        break;
      }
      case "process": {
        state.isProcessModal = value;
        state.processModalState = type;
        break;
      }
      case "archive": {
        state.isArchiveModal = value;
        state.processModalState = type;
        break;
      }
      case "unprocess": {
        state.isProcessModal = value;
        state.processModalState = type;
        break;
      }
      case "sign": {
        state.isSigningModal = value;
        state.signingModalState = type;
        break;
      }
      case "unsign": {
        state.isSigningModal = value;
        state.signingModalState = type;
        break;
      }
      case "billing": {
        state.isBillingModal = value;
        break;
      }
      case "nextSend": {
        state.isNextSendModal = value;
        break;
      }
      case "physician": {
        state.isPhysicianModal = value;
        state.isReportDetailModal = false;
        break;
      }
      case "patient": {
        state.isPatientModal = value;
        state.patientTab = "reports";
        state.isBillingEqual = true;

        if (value === false) {
          state.alertBanner = "";
        }

        break;
      }
      case "reportDetail": {
        state.isReportDetailModal = value;
        break;
      }
      case "previousReport": {
        state.isPreviousReportModal = value;
        break;
      }
      case "previousAlert": {
        state.isPreviousAlertModal = value;
        break;
      }
      case "pdfModal": {
        state.isPdfModal = value;
        break;
      }
      case "patientTask": {
        const { open, action, task } = value;
        state.isPatientTaskModal = open;
        state.patientTaskAction = action;
        state.currentPatientTask = task;
        state.originalPatientTask = task;
        break;
      }
      case "hl7job": {
        state.isHl7JobModal = value;
        break;
      }
      case "alertNotification": {
        state.isAlertNotificationModal = value;
        break;
      }

      case "signAndProcess": {
        state.isSignAndProcessModal = value;
        break;
      }

      case "physicianUnprocessFromClinicProcessed": {
        state.isPhysicianUnprocessFromClinicProcessedModal = value;
        break;
      }
      default:
    }
  },

  toggleProcessing: (state, action) => {
    state.isProcessing = action.payload;
  },

  toggleArchiving: (state, action) => {
    state.isArchiving = action.payload;
  },

  toggleReportProcessing: (state, action) => {
    const { type, value } = action.payload;

    if (type === SUBMIT_ACTIONS.ARCHIVE) {
      state.isReportArchiving = value;
    } else if (type === SUBMIT_ACTIONS.PROCESS) {
      state.isReportProcessing = value;
    } else {
      state.isReportUnProcessing = value;
    }
  },

  toggleReportSigning: (state, action) => {
    const { value } = action.payload;
    state.isReportUnsigning = value;
  },

  toggleSignAndProcessing: (state, action) => {
    const { type, value } = action.payload;
    if (type === SUBMIT_ACTIONS.SIGN_AND_PROCESS) {
      state.isSignAndProcessing = value;
    } else {
      state.isSignAndUnProcessing = value;
    }
  },

  changeNextSendDate: (state, action) => {
    state.nextSendDate = action.payload;
  },

  changeNextSendInformation: (state, action) => {
    const nextSendInformation = action.payload;
    const nextSendInformationStateData = {};

    const implantedBillingSchedule =
      nextSendInformation?.implanted_billing_schedule;

    if (implantedBillingSchedule) {
      const { day_31, day_91, day_custom } = implantedBillingSchedule;
      nextSendInformationStateData.day31 = day_31?.active ?? false;
      nextSendInformationStateData.day31BillingCode =
        day_31?.billing_code ?? "";

      nextSendInformationStateData.day91 = day_91?.active ?? false;
      nextSendInformationStateData.day91BillingCode =
        day_91?.billing_code ?? "";

      nextSendInformationStateData.customBillingDays = day_custom?.days ?? 0;
      nextSendInformationStateData.customDays = day_custom?.active ?? false;
      nextSendInformationStateData.customDaysBillingCode =
        day_custom?.billing_code ?? "";
    }

    nextSendInformationStateData.nextSendDate = nextSendInformation.next_send
      ? moment.utc(nextSendInformation.next_send).format("MM/DD/YYYY")
      : null;

    nextSendInformationStateData.nextBillingDate =
      nextSendInformation.next_bill_date
        ? moment.utc(nextSendInformation.next_bill_date).format("MM/DD/YYYY")
        : null;

    nextSendInformationStateData.nextSendDays =
      nextSendInformation.next_send_cycle ??
      DEFAULT_NEXT_TRANSMISSION_CYCLE_DAYS;
    nextSendInformationStateData.nextBillingDateChanged = false;

    state.nextSendInformation = nextSendInformationStateData;
  },

  updateNextBillingDateChangedStatus: (state, action) => {
    const nextBillingDateChangedStatus = action.payload;
    state.profile.nextBillingDateChanged = nextBillingDateChangedStatus;
  },

  selectedPhysicians: (state, action) => {
    const physicians = action.payload;

    if (physicians.length > 0) {
      physicians.forEach((physician) => {
        if (typeof physician !== "object") {
          state.physicians = action.payload;
        } else {
          state.physicians = [...state.physicians, physician.user_id];
        }
      });
    } else {
      state.physicians = [];
    }
  },

  setPreviousReport: (state, action) => {
    const { id, date, isLegacy, billingCode } = action.payload;

    state.previousReportId = id;
    state.reportDate = date;
    state.isPreviousReportLegacy = isLegacy;
    state.previousReportBillingCode = billingCode;
  },

  toggleMissingPatientDetailModal: (state, action) => {
    state.showMissingPatientDetailModal = action.payload;
  },
};
